module.exports = __webpack_public_path__ + "static/media/anohana.8704a4ca.jpg";